import { useUniverse } from '@front/pro/src/signup/signup-form-context';

import { useIsUserFromIndeed } from './use-is-user-from-indeed';

export const useShouldShowRevenueSimulator = () => {
  const isUserFromIndeed = useIsUserFromIndeed();
  const { universe } = useUniverse();

  return !isUserFromIndeed && universe === 'cleaning';
};
